import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { 
  MdSecurity, 
  MdCalculate, 
  MdAssessment, 
  MdPieChart, 
  MdArrowForward, 
  MdLayers 
} from "react-icons/md";

export default function HomeService() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  const coreServices = [
    {
      id: "01",
      icon: <MdSecurity />,
      title: "Statutory Auditing",
      subtitle: "Regulatory Rigor",
      desc: "Comprehensive external and statutory audits conducted under NBAA guidelines to protect entity value and maximize financial credibility.",
      anchor: "audit"
    },
    {
      id: "02",
      icon: <MdCalculate />,
      title: "Tax Consultancy",
      subtitle: "Strategic Optimization",
      desc: "Advanced tax planning, statutory returns management, compliance mapping, and proactive resolution of corporate tax disputes.",
      anchor: "tax"
    },
    {
      id: "03",
      icon: <MdAssessment />,
      title: "Management Advisory",
      subtitle: "Business Engineering",
      desc: "Tailored business advisory solutions designed to optimize operational parameters and drive stability across complex corporate scales.",
      anchor: "advisory"
    },
    {
      id: "04",
      icon: <MdPieChart />,
      title: "Accounting Solutions",
      subtitle: "Fiscal Infrastructure",
      desc: "Meticulous bookkeeping, outsourced finance management, and rigorous management reporting keeping your operations friction-free.",
      anchor: "accounting"
    }
  ];

  return (
    <section className="premium-services-section">
      
      {/* ==========================================================================
         CINEMATIC 3D BACKGROUND ENGINE: THE ARCHITECTURE OF WEALTH LATTICE
         ========================================================================== */}
      <div className="services-cinematic-3d-theater">
        
        {/* Structure 1: The Floating 3D Glass Executive Monolith (Left Flank) */}
        <div className="monolith-3d-cluster">
          <div className="monolith-glass-plate plate-back"></div>
          <div className="monolith-glass-plate plate-mid">
            <div className="plate-internal-laser-grid"></div>
          </div>
          <div className="monolith-glass-plate plate-front"></div>
          <div className="monolith-gold-core-ray"></div>
        </div>

        {/* Structure 2: Kinetic Vector Ribbons & Golden Matrix Nodes (Right Flank) */}
        <div className="kinetic-vector-3d-canvas">
          <div className="vector-3d-ribbon ribbon-alpha"></div>
          <div className="vector-3d-ribbon ribbon-beta"></div>
          <div className="matrix-glow-node node-1"></div>
          <div className="matrix-glow-node node-2"></div>
          <div className="matrix-glow-node node-3"></div>
        </div>

        {/* Dynamic Light Casting Engines */}
        <div className="ambient-studio-light light-top-indigo"></div>
        <div className="ambient-studio-light light-bottom-amber"></div>
      </div>
      
      <div className="container premium-services-container">
        
        {/* SECTION HEADER: Editorial & Highly Structured */}
        <div className="row justify-content-between align-items-end mb-5" data-open="true">
          <div className="col-lg-6 col-12" data-aos="fade-up">
            <div className="services-editorial-header">
              <div className="services-eyebrow">
                <span className="eyebrow-line" />
                <span className="eyebrow-text">Our Core Capabilities</span>
              </div>
              <h2 className="services-main-title">
                Engineered Financial <span className="title-gold-accent">Precision</span>
              </h2>
            </div>
          </div>
          <div className="col-lg-5 col-12 mt-3 mt-lg-0" data-aos="fade-up" data-aos-delay="100">
            <p className="services-header-lead">
              We translate multi-layered Tanzanian compliance mandates into clear corporate growth vectors, 
              bringing executive control back to your balance sheet.
            </p>
          </div>
        </div>

        {/* SERVICES CARD MATRIX GRID */}
        <div className="row g-4 style-services-grid-row">
          {coreServices.map((service, index) => (
            <div 
              className="col-xl-3 col-md-6 col-12" 
              key={service.id}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="premium-service-card mShadow1">
                <span className="service-card-index">{service.id}</span>
                <div className="card-accent-border-top" />
                
                <div className="service-card-body">
                  <div className="service-icon-cradle">
                    {service.icon}
                  </div>
                  
                  <div className="service-meta-text">
                    <span className="service-card-subtitle">{service.subtitle}</span>
                    <h4 className="service-card-title">{service.title}</h4>
                  </div>
                  
                  <p className="service-card-description">
                    {service.desc}
                  </p>
                </div>

                <div 
                  className="service-card-footer"
                  onClick={() => appContext.navTo({ item: "services", subItem: service.anchor })}
                >
                  <span className="footer-action-text">Explore Specialized Architecture</span>
                  <div className="footer-arrow-box">
                    <MdArrowForward />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* BOTTOM SECTION CTA STRIP */}
        <div className="row mt-5" data-aos="fade-up">
          <div className="col-12">
            <div className="services-panoramic-cta mShadow2">
              <div className="cta-left-content">
                <MdLayers className="cta-icon-decorative" />
                <div>
                  <h5>Seeking Custom Enterprise Financial Engineering?</h5>
                  <p>Our structural Friday technical review panels craft bespoke advisory frameworks tailored to multi-tiered business profiles.</p>
                </div>
              </div>
              <button 
                className="services-cta-button-outlined"
                onClick={() => appContext.navTo({ item: "contact" })}
              >
                <span>Initiate Corporate Consultation</span>
                <MdArrowForward />
              </button>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}